module.exports = __webpack_public_path__ + "img/login.d69b18aa.png";